export const rteNotifyPublishTypeAction = {
    CHANGE_FIRST: 'change:first',
    CHANGE: 'change',
    PUBLISH_DRAFT: 'draft',
    SUCCESS: 'success',
    SAVING: 'saving',
    REVERT_BACK: 'back',
    END_MEETING: 'meeting:close',
    START_MEETING: 'meeting:open',
    REMOVE_PERMISSION: 'remove_Permission',
    MENTION_USER_IN_CONTENT: 'content:add',
    MENTION_USER_IN_COMMENT: 'comment:add',
    PERMISSION_REMOVE: 'permission_remove',
    PERMISSION_CHANGE: 'permission_change',
    COMMENT_SUBMIT: 'comment:submit',
    COMMENT_CHANGE: 'comment:change',
    COMMENT_LIST_CHANGE: 'comment:list-change',
    SETGAZE_CHANGE: 'change:setgaze',
};

export const rteNotifyType = {
    WS: 'ws',
    INIT: 'init',
    EDITOR: 'editor',
    COLLABORATOR: 'collaborator',
    SAVE: 'save',
    PUBLISH: 'publish',
    REVERT: 'revert',
    MENTION: 'mention',
    BROADCAST: 'gateway_broadcast',
    PERMISSION: 'permission',
    COMMENT: 'comment',
    CORE_API: 'coreAPI',
    ATTACHMENT: 'attachment',
    DOC: 'doc',
    DOM: 'dom',
    TOKEN: 'token',
    LOG: 'log',
    PASTE: 'paste',
    BUSINESSLOG: 'businesslog',
    INPUT: 'input',
    WHITE_SCREEN: 'white_screen',
    ERROR: 'error',
    COMMENT_PERFORMANCE: 'commentPerformance',
    CHANGE: 'change',
    RLTODO_UPDATE: 'rltodo_update',
    HISTORY: 'history',
    PPT_REVERT: 'PPTrevert',
    CLOSE: 'close',
    CREATE: 'create',
    PALY: 'paly',
    EXPORT: 'export',
    // AIGC插件相关消息通知，如智能评分等
    AIGC_PLUGIN_MESSAGE_CHANGE: 'AIGCPluginMessageChange',

    // 选区变化
    SELECTION_CHANGE: 'selectionChange',

    CREATE_VIEW: 'createView', // 数据表创建视图
    UPDATE_SUM_TABLE: 'updateSummaryDatasheet', // 数据表合并表配置变化
};

export enum NotifyAction {
    OpenPanel = 'openPanel',
}

export const rteNotifyAction = {
    CLICK: 'click',
};

export const rteNotifyDocAction = {
    DELETE: 'delete',
    TITLE_CHANGE: 'change:title',
};

export const rteNotifyBroadcastType = {
    // 用户页面权限更变
    permission_change: 'permission_change',
    // 用户页面权限移除
    permission_remove: 'permission_remove',
    // 用户知识库权限更变
    repo_permission_change: 'repo_permission_change',
    // 用户知识库权限移除
    repo_permission_remove: 'repo_permission_remove',
    // 知识库权限属性变更
    repo_scope_change: 'repo_scope_change',
    // 文档标题变更
    doc_update: 'doc_update',
    // 文档被删除
    doc_delete: 'doc_delete',
};

export const rteNotifyWsAction = {
    success: 'connect:success',
    fail: 'connect:fail',
};

export const rteNotifyInitAction = {
    START: 'start',
    END: 'end',
    DOC_END: 'doc:end',
    PAGE_START: 'pageStart',
    FILE_OPEN: 'fileOpen',
};

export const rteNotifyDomAction = {
    DOM_READY: 'domReady',
    FS_DOM_READY: 'fsDomReady',
    CRITICAL_LOAD: 'criticalLoad',
    CRITICAL_LOAD_SHIMO: 'criticalLoadShimo',
};

export const MentionNotifyType = {
    comment: 1,
    content: 2,
    bottom_comment: 3,
};

export const endMeetingNotifyRefer = {
    USER: 'user',
    ROOM: 'room',
    SCRIPT: 'script',
};

export const rteNotifyCommentAction = {
    CHANGE: 'change',
    INIT: 'init',
    START: 'start',
    SUCCESS: 'success',
    FAIL: 'fail',
    ANCHOR_COMMENT_ADD: 'anchor_comment_add',
    COMMENT_REPLY: 'comment_reply',
    // 单播通知，防止浏览器窗口重复发送请求使用
    ANCHOR_COMMENT_NOTICE: 'anchor_comment_notice',
    ANCHOR_COMMENT_ADD_NOTICE: 'anchor_comment_add_notice',
    SAVECOMMENT_RELOAD: 'saveComment:reload',
    COMMENT_ADD_WHEN_UPLOADING: 'reply_when_uploading',
};

export const rteNotifyAttachmentAction = {
    UPLOAD_START: 'upload:start',
    UPLOAD_SUCCESS: 'upload:success',
    UPLOAD_FAIL: 'upload:fail',
    DOWNLOAD_START: 'download:start',
    DOWNLOAD_SUCCESS: 'download:success',
    DOWNLOAD_FAIL: 'download:fail',
};

export const rteNotifyCommentPerformanceAction = {
    ICON_CLICK: 'iconClick',
    COMMENT_PUBLISH: 'commentPublish',
};

export const rteNotifySaveStatusAction = {
    SUCCESS: 'success',
    SAVING: 'saving',
    FAIL: 'fail',
};

export const rteNotifyCollaboratorAction = {
    CHANGE: 'change',
    SAVE_SUCCESS: 'save:success',
};

export const rteNotifyErrorAction = {
    FILE_ERROR: 'fileError',
    ERROR: 'error',
    FAIL: 'fail',
};

export const rteNotifyOperateAction = {
    INTO_FULL_SCREEN: 'intoFullScreen',
    EXIT_FULL_SCREEN: 'exitFullScreen',
};

export const ErrorReason = {
    LINK_TIMEOUT: 'GetFileInfoFailed',
};

export const rteNotifyHistoryAction = {
    PRESENTATION_START: 'presentation:start',
    HISTORY_TAB_CHANGE: 'historyTab:change',
};

export const rteNotifyPPTRevertAction = {
    REVERT: 'revert',
};

/**
 * 数据表模板相关 action
 */
export const rteNotifyTemplateAction = {
    CLOSE_TEMPLATE_MODAL: 'close_template_modal',
    CREATE_NEW: 'create_new',
    CREATE_BY_TEMPLATE: 'create_by_template',
};

export const rteNotifyExportAction = {
    START: 'start',
    END: 'end',
};

export const rteNotifySlideAction = {
    SLIDE_INIT: 'slide:init',
    SLIDE_SHOWGUIDE: 'showguide:slide',
    SLIDE_CHANGE: 'slide:change',
};

export const rteNotifyCoverAction = {
    COVER_CHANGE: 'cover:change',
    COVER_APPLY: 'cover:apply',
};

export const rteNotifyPrintAction = {
    PRINT: 'print',
};

export const rteNotifyCardEditAction = {
    mergeCard: 'cardEdit:merge',
    splitCard: 'cardEdit:split',
    addCard: 'cardEdit:addNew',
    cardEventHover: 'cardEvent:hover',
};
